import { Link } from "react-router-dom";
import { X, Instagram, Facebook } from "lucide-react";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Collection", path: "/collection" },
  { name: "Send a Thought", path: "/collection?tag=Thought%20of%20You" },
  { name: "Memberships", path: "/memberships" },
  { name: "Bespoke", path: "/bespoke" },
  { name: "Events", path: "/events" },
  { name: "Floral Bar", path: "/floral-bar" },
  { name: "Manifesto", path: "/manifesto" },
  { name: "FAQ", path: "/faq" },
  { name: "Inquiries", path: "/inquiries" },
];

export default function MobileMenu({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] bg-[#0c0c0c] flex flex-col"
      data-testid="mobile-menu"
    >
      {/* Close Button */}
      <div className="flex justify-end p-6">
        <button
          onClick={onClose}
          className="p-2 text-[#f8f5f0] hover:text-[#b8966a] transition-colors"
          data-testid="mobile-menu-close"
          aria-label="Close menu"
        >
          <X size={24} />
        </button>
      </div>

      {/* Navigation Links */}
      <div className="flex-1 flex flex-col items-center justify-center gap-6">
        {navLinks.map((link, index) => (
          <Link
            key={link.path}
            to={link.path}
            onClick={onClose}
            className="font-display text-sm tracking-[0.3em] uppercase text-[#f8f5f0] hover:text-[#b8966a] transition-colors animate-fade-in"
            style={{ animationDelay: `${index * 0.05}s` }}
            data-testid={`mobile-nav-${link.name.toLowerCase().replace(' ', '-')}`}
          >
            {link.name}
          </Link>
        ))}
      </div>

      {/* Social Links */}
      <div className="flex justify-center gap-8 pb-12">
        <a
          href="https://instagram.com/fleurisnoir"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#a19d98] hover:text-[#b8966a] transition-colors"
          data-testid="mobile-social-instagram"
        >
          <Instagram size={20} />
        </a>
        <a
          href="https://facebook.com/fleurisnoir"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#a19d98] hover:text-[#b8966a] transition-colors"
          data-testid="mobile-social-facebook"
        >
          <Facebook size={20} />
        </a>
      </div>
    </div>
  );
}
